import { Component, Input } from '@angular/core';
import { Patient } from '../../../models/patient';
import { TraitementDataComponent } from '../traitement-data/traitement-data.component';
import { ALaDateDuPipe } from '../../../pipes/a-la-date-du.pipe';

@Component({
  selector: 'app-traitement-data-o2-effort',
  standalone: true,
  imports: [TraitementDataComponent, ALaDateDuPipe],
  templateUrl: './traitement-data-o2-effort.component.html',
  styleUrl: './traitement-data-o2-effort.component.scss',
})
export class TraitementDataO2EffortComponent {
  @Input() patient: Patient | undefined;
}
